import React, { useState, useEffect } from "react";
import HeaderLeft from "./HeaderLeft";
import pandding from "../assets/images/pandding.png";
import { Link, useNavigate } from "react-router-dom";
import DropdownRight from "./DropdownRight";
import http from "../services/http";
import GetStorage from "../services/Storage";
import { ToastContainer } from "react-toastify";
import { showToast } from "./ShowToast";
import storage from "../services/Storage";

function Available(props) {
  let user = localStorage.getItem("user");
  user = JSON.parse(user);

  const token = GetStorage.get("xAuthToken");
  const [availibility, setavailibility] = useState(user.data.is_available);
  const work_limit = user.data.work_limit;
  const navigate = useNavigate();

  const availibilityChange = (e) => {
    console.log(e.target.checked);
    const v = e.target.checked === true ? 1 : 0;
    setavailibility(v);

    http
      .put(`api/analyst/settings?token=${token}`, {
        is_available: v,
        work_limit,
      })
      .then((res) => {
        console.log("admin team select", res.data);
        showToast("success", res.data.message);
      })
      .catch((error) => {
        console.log("error ", error.response.data.errors);
      });
    http
      .get(`api/common/me?token=${token}`)
      .then((res) => {
        const newUser = user;
        newUser.data = res.data;
        storage.store("user", newUser);
      })
      .catch((err) => {
        console.log("error ", err.response.data.errors);
      });
  };

  useEffect(() => {
    const isApproved = storage.get("isApproved");
    console.log("is approved----", isApproved);
    if (isApproved == 1) {
      navigate("/available");
    } else {
      navigate("/welcomePersonalInfo");
    }
  }, []);

  return (
    <>
      <header>
        <div class="custom_container ">
          <HeaderLeft />
          <div class="user_profile">
            <DropdownRight />
          </div>
        </div>
      </header>
      <section class="otp_verification custom_hight">
        <div class="login_inner">
          <h1 class="mb_30 main_title ">Welcome {user.data.firstname}</h1>
          <p class="mb_40 them_para text-center mx-auto text_limit"></p>
          <div class="switch_wraper">
            <input
              type="checkbox"
              hidden="hidden"
              id="username"
              onChange={availibilityChange}
              checked={availibility === 1 ? true : false}
            />
            {availibility === 1 ? "Available" : "Unavailable"}
            <label class="switch" for="username"></label>
          </div>
          <div class="custom_with_avilable">
            <div class="row">
              <div class="col-lg-4 col-md-4 col-sm-6">
                <div class="box_work">
                  <div class="img-wraper">
                    {" "}
                    <img src={pandding} alt="" />{" "}
                  </div>
                  <Link to="/work">
                    <h6 class="sub_title  ">Work</h6>
                  </Link>
                </div>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-6">
                <div class="box_work">
                  <div class="img-wraper">
                    {" "}
                    <img src={pandding} alt="" />{" "}
                  </div>
                  <Link to="/completed">
                    <h6 class="sub_title  ">Completed</h6>
                  </Link>
                </div>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-6 mx-auto">
                <div class="box_work">
                  <div class="img-wraper">
                    {" "}
                    <img src={pandding} alt="" />{" "}
                  </div>
                  <Link to="/analystApplication">
                    <h6 class="sub_title  ">Applicants</h6>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <ToastContainer />
    </>
  );
}

export default Available;
